import type { FC } from "react";

interface LessonItemIndexProps {
  index: number;
}

/** Displays the lesson number index */
export const LessonItemIndex: FC<LessonItemIndexProps> = ({ index }) => {
  const number = index + 1;

  return (
    <div className="w-6 text-center">
      <span className="text-xs font-medium text-muted-foreground">
        {number}
      </span>
    </div>
  );
};
